export const ASSETS = {
  logo: "https://customer-assets-0z36b82j.emergentagent.net/job_2e45204e-4cdd-41f1-8286-39eb039742f4/artifacts/2a33c742b94b77f5_60F61B03-330D-4D4C-8820-459133A15B59.png",
  heroBanner: "https://customer-assets-0z36b82j.emergentagent.net/job_2e45204e-4cdd-41f1-8286-39eb039742f4/artifacts/093a073c0b6c26b7_0D7A5982-02F8-44E7-9B8A-B9BAB7E5A105.webp",
  poster: "https://customer-assets-0z36b82j.emergentagent.net/job_2e45204e-4cdd-41f1-8286-39eb039742f4/artifacts/a27990665a4ea760_AD51A5CF-A577-4DD1-B555-1475EF47A897.png",
  // Authentic fleet photography (owner-provided)
  heroUrus: "https://customer-assets-4nw71qhi.emergentagent.net/job_aa-motors-fleet/artifacts/deade0d8bf8efa4d_IMG_5172.jpeg",
  urusYellow: "https://customer-assets-4nw71qhi.emergentagent.net/job_aa-motors-fleet/artifacts/6af3bf3d9d9324ae_IMG_5142.jpeg",
  g63Black: "https://customer-assets-4nw71qhi.emergentagent.net/job_aa-motors-fleet/artifacts/0a5334fb5c0494c1_e4b1454d-847e-4b61-8fda-91a1d49d3560.jpeg",
  gBrabusPink: "https://customer-assets-4nw71qhi.emergentagent.net/job_aa-motors-fleet/artifacts/dd86ee6616474841_IMG_5114.jpeg",
  rrInterior: "https://customer-assets-4nw71qhi.emergentagent.net/job_aa-motors-fleet/artifacts/ac3427e27dfef6cf_IMG_5105.jpeg",
  dubaiDusk: "https://images.pexels.com/photos/3372408/pexels-photo-3372408.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const CONTACT = {
  uaeDisplay: "+971 56 677 7068",
  uaeTel: "tel:+971566777068",
  deDisplay: "+49 174 6793581",
  deTel: "tel:+491746793581",
  whatsapp: "https://wa.me/qr/GJYGPHN5YXWWP1",
  whatsappAlt: "https://wa.me/message/Y5Z7H2LJIUZTL1",
  whatsappDirect: "https://wa.me/491746793581",
};

export const buildWhatsAppEnquiry = (form, vehicleName) => {
  const lines = [
    "Hi A&A MOTORS! Booking enquiry:",
    `Name: ${form.name}`,
    `Vehicle: ${vehicleName || "Any / advise me"}`,
    `Dates: ${form.pickup_date} to ${form.return_date}`,
    `Handover: ${form.handover === "delivery" ? "Delivery to me" : "I will pick up the car"}`,
    `Phone: ${form.phone}`,
    `Email: ${form.email}`,
  ];
  if (form.message) lines.push(`Message: ${form.message}`);
  return `${CONTACT.whatsappDirect}?text=${encodeURIComponent(lines.join("\n"))}`;
};

export const SOCIALS = [
  { name: "Instagram", icon: "instagram", href: "https://www.instagram.com/a.a.motors_", testId: "social-instagram", live: true },
  { name: "TikTok", icon: "tiktok", href: "https://www.tiktok.com/@a.a.motors_", testId: "social-tiktok", live: true },
  { name: "Facebook", icon: "facebook", href: "https://www.facebook.com/share/1Dvn4Xi8zU/", testId: "social-facebook", live: true },
  { name: "LinkedIn", icon: "linkedin", href: "https://www.linkedin.com/in/maximilian-schmidt-24a17633a", testId: "social-linkedin", live: true },
];

export const CATEGORIES = ["economy", "everyday", "sedans", "suv", "luxury", "sports", "supercars"];

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72 });
  } else {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};
